<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                Receiving Supplier Form
                <div class="card-header-actions">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
              <b-row>
                <b-col md="6">                            
                    <b-input-group>
                        <b-input-group-append><span class="input-group-text">Order Date</span></b-input-group-append>
                        <b-form-input v-model="model.orderdate" type="date" disabled></b-form-input>                                        
                        <b-input-group-prepend><span class="p-2">Order Number</span></b-input-group-prepend>
                        <b-form-input v-model="model.orderno" readonly></b-form-input>
                    </b-input-group>
                </b-col>
                <b-col md="6">
                    <b-input-group >
                        <b-input-group-prepend><label>Supplier/Vendor</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.vendorinfo" :state="!$v.model.vendor_id.$error"></b-form-input>
                        <b-input-group-append>
                        </b-input-group-append>
                    </b-input-group>                                        
                </b-col>
              </b-row>
              <b-card no-body class="mb-1">
                <b-table-simple hover small responsive bordered>                    
                    <b-thead head-variant="light">
                        <b-tr>
                            <b-th style="width:50px;" variant="light">No.</b-th>
                            <b-th style="min-width:295px;" variant="light">Item</b-th>
                            <b-th style="text-align:right" width="80px" >Unit Size</b-th>
                            <b-th style="text-align:right" width="120px" >Purc.Price</b-th>
                            <b-th style="text-align:right" width="100px" >Qty Order</b-th>
                            <b-th style="text-align:right" width="120px" >Qty Received</b-th>
                            <b-th style="text-align:right" width="140px" >Amount Order</b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <b-tr  v-for="(row,idx) in ordLines.items" :key="row.podtlkey">
                            <b-td > {{idx+1}}</b-td>
                            <b-td > {{row.itemname}}</b-td>
                            <b-td  style="text-align:right" >
                                {{row.unitsize}}
                            </b-td>
                            <b-td  style="text-align:right" >
                                {{row.unitprice | numFormat}}
                            </b-td>
                            <b-td  style="text-align:right" >
                                {{row.quantity | numFormat}}
                            </b-td>
                            <b-td  style="padding:0 !important;">
                                  <input type="number" v-on:click.ctrl="row.qtyreceived=row.quantity" v-model="row.qtyreceived" style="width:100%; border:none;" class="text-right" :min="0" />
                            </b-td>
                            <b-td  style="text-align:right" >
                                {{row.nilai | numFormat}}
                            </b-td>
                        </b-tr>
                        </b-tbody>
                    </b-table-simple>

              </b-card>    
            <b-row class="justify-content-center mt-1">
                <div style="width:300px;">
                    <b-input-group >
                        <b-input-group-append>
                            <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                        </b-input-group-append>
                        <b-input-group-append>
                            <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </b-row>

        </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       

    </div>
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 80px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import procure from "../../apis/bakeryorder";
import { validationMixin } from "vuelidate";
import { required, numeric, decimal } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { Loading, myNumber},
  mixins: [validationMixin],
  validations: {
        model: {
            orderdate: { required },
            vendor_id: { required },
            remark: { required:false },
            matauang: { required },
        },
  }, 
  data() {
    return {
        saveEnabled:true,
          isLoading:false,
      inputBerlanjut: 0,
      inputLineBerlanjut: 1,
        lkuVendorShow: false,
        tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
        uanguser: this.$store.state.user.matauang,
        currency:[{value:'IDR',text:'IDR'}],
        calcVAT:1,
        calcuationVAT : [{ value: 1, text: 'VAT (Auto Calc)' }, { value: 0, text: 'VAT (Manual Calc)' }],
        calcPPh:1,
        calcuationPPH : [{ value: 1, text: 'Nilai PPH(Otomatis)' }, { value: 0, text: 'Nilai PPH(Manual)' }],
        lookupPPH:[],
        customers:[],
        items:[],itemprice:[],
        ordLines: {
            items: [],
        },
        model: {
            jasa: 0,
            orderdate: moment().format('YYYY-MM-DD'),
            vendor_id: '',
            vendor: '',
            requestno: '',
            ExpectRcv: '',
            remark: '',
            postgroup: '',
            typegroup:'OPEX', 
            matauang:this.$store.state.user.matauang, 
            compcode:this.$store.state.user.compcode,
            invterm: 'COD',
            kodecash: '',
            terms:[], 
            locationdeliv:this.$store.state.user.compaddr},
        tabIndex:0,
    };
},
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  created: async function(){
        if (this.$route.params.pohdrkey)  {
          toastr.info('Loading Order Detail, please wait')
          try {
            const [a,b,data] = await Promise.all([procure.customeraktif(), procure.itemaktif(),procure.detail(this.$route.params)]) ;
            this.customers = a;
            this.items = b;  
            const row = data[0][0];
            row.orderdate = row.orderdate ? moment(row.orderdate).format('YYYY-MM-DD') : '';
            // row.expectreceipt = row.expectreceipt ? moment(row.expectreceipt).format('YYYY-MM-DD') : '';
            for (var key in row) {
                this.model[key] = row[key];
            }
            if (row.orderdate<this.$store.state.user.tglaktif){
                this.saveEnabled=false;
            }            
            this.ordLines.items = data[1];
            this.ordLines.total = this.ordLines.items.length;
            this.items.forEach((item)=> {
                const idx = this.ordLines.items.findIndex(d => d.itemno==item.itemno)
                if (idx==-1){
                    this.ordLines.items.push({itemno:item.itemno, partnumber:item.partnumber, itemname:item.itemname, 
                    unitprice: item.unitcost, saleprice: item.unitprice });
                }
            });
            // procure.supplierprice({ vendor_id: this.model.vendor_id}).then(result => {
            //         this.itemprice = result;
            //     })
            //     .catch(err => {
            //         console.log('item supplierprice -> ', err);
            //     });

            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
        } else {
            this.saveEnabled=false;
        }
  },
  methods: {
    onFiltered(filteredItems) {
      this.ordLines.total = filteredItems.length;
    },      
    save: async function () {
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        this.saveEnabled=false;            
        if (this.invalidModel) {
            console.log('validation : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.saveEnabled=true;            
        } else {
            try {
                this.isLoading=true;            
                this.model.TableName = 'po_header';

                // this.model.DimTableKey = diisi dari PR/SR;
                    this.model.pohdrkey = this.model.pohdrkey || '';
                    this.model.orderno = this.model.orderno || '';
                    const row = {};
                    for (var key in this.model) {
                        row[key] = this.model[key];
                    }
                    row.terms = this.model.terms;
                    row.orderdate = moment(row.orderdate).format('YYYY-MM-DD');
                    row.expectreceipt = row.expectreceipt ? moment(row.expectreceipt).format('YYYY-MM-DD') : undefined;
                    let lineno=1;
                    row.lines = this.ordLines.items.reduce((newArr, item) => {
                        if ((item.itemno || '') != '') {
                            item.lineno = lineno;
                            newArr.push(item);
                            lineno += 1;
                        }
                        return newArr;
                    }, []);
                    if (row.lines.length>0) {
                        await procure.savereceiving(row);
                        this.isLoading=false;            
                        toastr.success(`Save Successfully`, "Receiving Supplier",10000);
                        this.close();
                    } else {
                        toastr.error('Please fill at least 1(one) Order Detail', 'ERROR MESSAGE');
                        this.saveEnabled=true;
                        this.isLoading=false;            
                    }
            } catch (error) {
                this.isLoading=false;            
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
                this.saveEnabled=true;            
            }

        }
    },

    calcTotQty: function(record){
        setTimeout(() => {
            record.quantity=0;
            this.customers.forEach((kol)=>{
                record.quantity += parseFloat(record[`K${kol.CustCode}`] || 0) ;
            });
        }, 100);
        this.calcPrice(record);
    },
    calcTotalDtlOrder: function () {
        this.calcVAT = this.calcVAT || 1;
        let nilaippn = 0;
        let ttlnetto = 0;
        let ttlamtdue = 0;
        // let totalpph = 0;
        this.ordLines.items.forEach( function (trx) {
            if (trx.itemno) {
                ttlnetto += (trx.nilai || 0);
                nilaippn += (trx.nilaippn || 0);
                ttlamtdue = ttlnetto + (nilaippn || 0);
                // totalpph += parseFloat(trx.nilaipph || 0);
            }
        });
        this.model.ttlnetto = ttlnetto;
        if (this.calcVAT == 1){
            this.model.nilaippn = nilaippn;
        }
        this.model.ttlamtdue = ttlamtdue;
        // this.model.totalpph = totalpph;
    },    
    calcAmountDue : function() {
        this.model.ttlamtdue = parseFloat(this.model.ttlnetto || 0) + parseFloat(this.model.nilaippn || 0);
    }, 
    calcTaxes : function(record) {
        record.nilainett = parseFloat(record.nilai) - parseFloat(record.nilaidisc || 0);
        record.dpp = parseFloat(record.nilai) * parseFloat(record.dppnlain) / 100;
        if (record.kenappn == 1) {
            record.ppn = record.ppn || 11;
        } else {
        // if ((record.ppn || 0) == 0 ) {
            // record.kenappn = 0;
            record.dpp = 0;
            record.ppn = 0;
        }
        // if (this.model.grossup == 1)
        //     record.dpp = record.dpp * (100 / (100 - record.pph));

        record.nilaippn = parseFloat(record.ppn) / 100 * record.dpp;
        record.nilaidue = record.nilainett + record.nilaippn;
    },

    calcPrice : function(record) {
        record.nilai = parseFloat(record.quantity) * parseFloat(record.unitprice);
        if (record.disc > 0) {
            record.nilaidisc = record.disc * record.nilai / 100.0;
        };
        // this.ordLinesObj.nilainett = this.ordLinesObj.nilai - parseFloat(this.model.nilaidisc || 0);
        this.calcTaxes(record);
    },
    calcPriceDelay : function(record) {
        setTimeout(() => {
            record.nilai = parseFloat(record.quantity) * parseFloat(record.unitprice);
            if (record.disc > 0) {
                record.nilaidisc = record.disc * record.nilai / 100.0;
            };
            
        }, 100);
    },

    tanggalBerubah: function(){
        this.tahun=moment(this.model.tanggal).format('YYYY');
    },

    close(){
    //   console.log('this.$store.state.prevRoute.name : ',this.$store.state.prevRoute.name);
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'bakery.receivingsupplierfrm')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        // router.push({name:'payable.apinv'});
          router.push("home");
      }
    }
  }
};
</script>
